module.exports = __webpack_public_path__ + "img/people_img_4_1.adbf90ff.png";